import { HelpLink } from "./HelpTip";

export default function PageHeader({ eyebrow, title, description, actions, testid, help }) {
  return (
    <div className="border-b border-neutral-900 px-8 py-7 flex items-end justify-between gap-6" data-testid={testid}>
      <div>
        {eyebrow && <div className="label-mini">{eyebrow}</div>}
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight font-bold mt-2 leading-none">
          {title}
          {help && (
            <span className="ml-3 inline-flex align-middle">
              <HelpLink anchor={help} label={typeof title === "string" ? title : "Page"} testid="page-help-link" />
            </span>
          )}
        </h1>
        {description && (
          <p className="text-sm text-neutral-500 mt-3 max-w-xl" data-testid="page-intro">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}
